"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonHeaderService = void 0;
const is_blank_1 = __importDefault(require("@sedan-utils/is-blank"));
class CommonHeaderService {
    constructor(authStore, projectStore) {
        this.authStore = authStore;
        this.projectStore = projectStore;
    }
    get() {
        const brainToken = this.authStore.state.brainToken;
        const guestToken = this.authStore.state.guestToken;
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        let headers = {
            "X-Brain-User-Tz": tz,
            "Content-Type": "application/json",
        };
        if (!(0, is_blank_1.default)(brainToken)) {
            headers["Authorization"] = `token ${brainToken}`;
        }
        else if (!(0, is_blank_1.default)(guestToken)) {
            headers["Brain-Guest-User-Key"] = guestToken;
        }
        const attrIndexer = this.projectStore.attrIndexer;
        if (!(0, is_blank_1.default)(attrIndexer)) {
            headers["X-Brain-Imagica-Id"] = attrIndexer;
        }
        return headers;
    }
}
exports.CommonHeaderService = CommonHeaderService;
